import React, { useEffect, useState } from "react";
import usePasses from "./hooks/usePasses";
import SinglePass from "./SinglePass";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import useFacility from "../../../utils/hooks/useFacility";
import ModalWindowPass from "../ModalWindow/passesModal/passesModal";
import { useSelector } from "react-redux";
import { State } from "../../store";

const PassesPage: React.FC = () => {
  const { requestGetAssortGroups, passes } = usePasses();
  const facilityIds = useFacility();
  const [openModal, setOpenModal] = useState(true);
  const handleOpenPassModal = () => {
    setOpenModal(!openModal);
  };
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const [passIndex, setPassIndex] = useState(99);
  const handlePassIndex = (index: number) => {
    setPassIndex(index);
  };

  useEffect(() => {
    if (Boolean(facilityIds)) {
      requestGetAssortGroups();
    }
  }, [facilityIds]);

  return (
    <div>
      {openModal && (
        <div className="headline">
          {saleConfiguration.componentList && (
            <React.Fragment>
              {saleConfiguration.componentList.map((item) => (
                <React.Fragment>{item.id === "PassSale" && <h1>{item.name}</h1>}</React.Fragment>
              ))}
            </React.Fragment>
          )}

          <div className="line"></div>

          {saleConfiguration.message_passes && (
            <React.Fragment>
              {saleConfiguration.message_passes.length > 12 ? (
                <div className="alert alert-comment">
                  <article dangerouslySetInnerHTML={{ __html: saleConfiguration.message_passes }}></article>
                </div>
              ) : (
                <React.Fragment></React.Fragment>
              )}
            </React.Fragment>
          )}
        </div>
      )}

      <div className="flex-start flex-wrap">
        {passes.map((item, index) => (
          <React.Fragment>
            {openModal ? (
              <SinglePass
                handleOpenPassModal={handleOpenPassModal}
                handlePassIndex={handlePassIndex}
                key={index}
                item={item}
                index={index}
              />
            ) : (
              <React.Fragment>
                {passIndex === index && <ModalWindowPass item={item} handleOpenPassModal={handleOpenPassModal} />}
              </React.Fragment>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default PassesPage;
